import {backAdmin} from "../axios";

export const systemEditionApi = [
    {url: `${backAdmin}/system/landing`, name: 'system.landing.all', method: 'GET'},
    {url: `${backAdmin}/system/landing`, name: 'system.landing.create', method: 'POST'},
    {url: `${backAdmin}/system/landing/{id}`, name: 'system.landing.byId', method: 'GET'},
    {url: `${backAdmin}/system/landing/{id}`, name: 'system.landing.update', method: 'PUT'},
    {url: `${backAdmin}/system/landing/{id}`, name: 'system.landing.delete', method: 'DELETE'},
    {url: `${backAdmin}/system/landing/{id}/status`, name: 'system.landing.update.status', method: 'PUT'},
    {url: `${backAdmin}/system/landing/{id}/image`, name: 'system.landing.update.image', method: 'POST'},
    {url: `${backAdmin}/system/landing/{id}/image`, name: 'system.landing.delete.image', method: 'DELETE'},
]